<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">设备场景</span>
      </div>
      <div class="right">
        <Button type="primary"  @click="modal = {visible: true,data: {}}">新增设备场景</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data"/>
    <Modal v-model="modal.visible" title="场景类型" width="270">
      <Input placeholder="场景名称" v-model="modal.data.name">
        <span slot="prepend">名称</span>
      </Input/>
      <div slot="footer">
        <Button @click="modal.visible = false">取消</Button>
        <Button @click="save" v-preventReClick type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      data: [],
      columns: [
        { key: 'id', title: '编号' },
        { key: 'name', title: '场景类型' },
        { key: 'operate',
          title: '操作',
          render: (h, data) => {
            return h('div', {}, [h('Button', {
              props: { size: 'small', type: 'warning' },
              on: {
                click: () => {
                  this.modal = {
                    visible: true,
                    data: JSON.parse(JSON.stringify(data.row))
                  }
                }
              }
            }, '编辑')])
          } }
      ],
      modal: {
        visible: false,
        data: {}
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    save () {
      if (!this.modal.data.name) {
        this.$Message.error('请输入场景名称')
        return
      }
      let data = JSON.parse(JSON.stringify(this.modal.data))
      this.SaveScene(data).then(res => {
        this.$Message.success('操作成功')
        this.modal.visible = false
        this.getData()
      })
    },
    getData () {
      this.GetScene().then(res => {
        this.data = res
      })
    },
    ...mapActions(['GetScene', 'SaveScene'])
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
